export const FACEBOOK_ID = '497208761188236';
export const FACEBOOK_PAGE_ID = '100353748133080';
